import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

// Init Day.js before bootstrapping the application
import './plugins/dayjs-init';

const enableFederation = false;

if (enableFederation && (environment.STAGE === 'production' || environment.STAGE === 'sandbox')) {
    initFederation()
        .catch((err) => console.error(err))
        .then((_) => import('./bootstrap'))
        .catch((err) => console.error(err));
} else {
    import('./bootstrap').catch((err) => console.error(err));
}
